module.exports = __webpack_public_path__ + "img/1.2f86c3cb.jpg";